/**
 * Адрес SSE-роутов помощника (Task 3, решение по транспорту): в проде бэкенд
 * напрямую (WS-домен из VITE_ASSISTANT_API_ORIGIN в .env.production, тот
 * же сервис, что WebSocket-подписки; имя хоста здесь не пишется: исходник
 * попадает в source map, а adult-деплой ищет его в build/assets), потому что реврайт Firebase Hosting на Cloud Run
 * обрывает ответ через 60 секунд; в деве пусто, запрос идёт через прокси
 * Vite /api/assistant. Отдельный модуль, чтобы тесты подменяли его
 * jest.mock (import.meta).
 */
export const ASSISTANT_API_ORIGIN: string =
  import.meta.env.VITE_ASSISTANT_API_ORIGIN ?? "";
